// tslint:disable: max-line-length
import React from "react";
import _ from "underscore";
import { Avatar, LazyLoadImage, LineDots } from "../../../../../core/atoms";

import "./aboutOurStory.scss";

export const AboutOurStory = () => {
  return (
    <div className="about-our-story width-wrapper">
      <LazyLoadImage
        className="about-our-story__image"
        src={ourStoryImage}
        alt="The town of Ubud on the Indonesian island of Bali"
      >
        <div className="about-our-story__dots">
          <LineDots
            x1="50%" y1="0" x2="50%" y2="100%"
            colour="#fff" />
        </div>
      </LazyLoadImage>
      <div className="about-our-story__body" >
        <div className="about-our-story__content">
          <h2 className="about-our-story__title">Our Story</h2>
          <p className="about-our-story__text">
            TravelLocal started life in 2008 as an idea shared by our founders, Tom and Huw. At the time, both were fully immersed in other areas of the travel industry and couldn’t help but feel that something was missing. Big tour operators were dominating the market and the local experts that planned the trips were treated as a “trade secret”. They started TravelLocal to change that.</p>
          <p className="about-our-story__text">
            Since 2012 we have scoured the globe to find travel experts from Argentina to Zanzibar and anywhere in between, enabling travellers to plan their holidays direct with the people who know their destination best. You get a better, more authentic holiday experience and our local experts get a fairer deal. For peace of mind, we are members of ABTA, ASTA and ATOL and your booking is 100% financially protected.
            </p>

          <Avatar className="about-our-story__avatar" source="https://resources.travellocal.com/about-us/huw-and-tom.jpg" alt="Huw Owen and Tom Stapleton - Joint Managing Directors &amp; Co-Founders" />
        </div>
      </div>
    </div>
  );
};

const ourStoryImage: ISrcSet = {
  default: `https://resources.travellocal.com/about-us/our-story_large.jpg`,
  srcs: [
    {
      src: `https://resources.travellocal.com/about-us/our-story_medium.jpg`,
      width: 960, // intrinsic width
    },
    {
      src: `https://resources.travellocal.com/about-us/our-story_large.jpg`,
      width: 1920, // intrinsic width
    },
  ],
};
